import { render, staticRenderFns } from "./TaskItemTr.vue?vue&type=template&id=3cca19e9"
import script from "./TaskItemTr.vue?vue&type=script&lang=ts"
export * from "./TaskItemTr.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports